import React from 'react';
import {useStores} from "../stores/Context";
import SidebarWidgets from "./SidebarWidgets/SidebarWidgets";

const URLMetier = () => {
    const {widgetStore, uiStore} = useStores();
    const idWidget = uiStore.idWidgetShow;
    const urlWidget = uiStore.urlWidgetShow;
    let url = ""

    if (urlWidget) {
        url = urlWidget;
    } else {
        url = widgetStore.widgetsAvailable.filter(widget => widget.idWidget === idWidget)[0].config.url;
    }

    return (
        <div className={`widgetShow ${uiStore.isPanelOpened ? 'sidebarActive' : ''}`}>
            <SidebarWidgets />
            <iframe className={""} src={url} frameBorder="0" title={"Url Métier"}/>
        </div>
    );
};

export default URLMetier;